import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Enums } from '@cyborg-monorepo/hunter/common';
import { Observable } from 'rxjs';
import { UserService } from '../modules/shared/services/user.service';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    public router: Router,
    private authService: AuthService,
    private userService: UserService,
  ) {}

  /**
   * Allows users to navigate new pages if they are logged in. If the refresh token
   * has reached the half waypoint, then also update the refresh token
   * and allow user to pass on success.
   */
  public canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | Observable<boolean> | UrlTree {
    if (this.authService.isAuthenticated()) {
      this.userService.getProfile().subscribe((profile) => {
        if (profile.company.status == Enums.CompanyStatus.EXPIRED) {
          this.router.navigateByUrl('premium-gate');
        }
      });
      return true;
    }

    // Capture attempted target URL and set as next requested login redirect URL
    this.authService.setLoginRedirectPath(state.url);

    return this.router.parseUrl('/login');
  }
}
